import React, { useState } from 'react';
import { useTranslate, useCurrentUser, useShallowEqualSelector } from '@hooks';
import {
  ApiKeysClipboard,
  DocsTimezoneModal as Modal,
  RequestLimitAlert,
} from '@dotone/react-ui-core';
import DocsCommonParams from './DocsCommonParams';
import DocsCommonResponse from './DocsCommonResponse';
import DocsRequestClipboard from './DocsRequestClipboard';
import DocsResponseTabset from './DocsResponseTabset';
import { stats as codes } from './data';
import { useApiUrl } from './helpers';

const Section = (props) => <div className="pb-3" {...props} />;

const DocsStats = ({ ...otherProps }) => {
  const { t, tHtml, locale } = useTranslate('docs', 'stats');
  const { currentUser } = useCurrentUser();
  const { apiKeys } = useApiUrl();
  const apiKeyProps = { user: currentUser, apiKeys };
  const [isOpen, setOpen] = useState(false);
  const { data, isLoading } = useShallowEqualSelector(({ timezoneList }) => ({
    ...timezoneList,
    ...timezoneList[locale],
  }));
  const handleClick = (e) => {
    e.preventDefault();
    if (e.target.id === 'timezones') {
      setOpen(true);
    }
  };

  const handleToggle = () => {
    setOpen(!isOpen);
  };

  return (
    <>
      <div {...otherProps}>
        <Section>
          {tHtml('body')}
          <RequestLimitAlert />
        </Section>
        <Section>
          <ApiKeysClipboard {...apiKeyProps} />
          <DocsRequestClipboard path="stats" />
        </Section>
        <Section>
          <DocsCommonParams />
        </Section>
        <Section onClick={handleClick}>{tHtml('params')}</Section>
        <Section>
          <DocsCommonResponse />
        </Section>
        <Section>
          <h6 className="text-dark-light">{t('docs:responseMeta')}</h6>
          {tHtml('meta')}
        </Section>
        <Section>
          <h6 className="text-dark-light">{t('docs:responseData')}</h6>
          {tHtml('response')}
        </Section>
        <Section>
          <DocsResponseTabset codes={codes} />
        </Section>
      </div>
      <Modal isOpen={isOpen} data={data} isLoading={isLoading} onToggle={handleToggle} />
    </>
  );
};

export default React.memo(DocsStats);
